module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.7141/images/default-company-avatar.png"